import React, { useEffect, useState } from "react";
import PageError from "./GenericError";

const ErrorBoundary = ({ children }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    const errorHandler = (errorCatch) => {
      if (errorCatch?.filename && errorCatch.filename.includes("clarity.js")) {
        console.warn("Erro do Clarity ignorado:", errorCatch);
        return;
      }

      console.error("Erro capturado:", errorCatch);
      setError(true);
    };

    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  return (
    <>
      {error ? <PageError /> : children}
    </>
  );
};

export default ErrorBoundary;
